import { Avatar, AvatarSize } from '@xemplo/avatar';
import { ButtonType, ButtonVariant } from '@xemplo/button';
import { EditPayrunApprovers } from '@xemplo/edit-payrun-approvers';
import { DawnTrash } from '@xemplo/icons';
import { Modal, ModalDialogSlot } from '@xemplo/modal-dialog';

import { DeletePrompt } from './delete-prompt';
import { ModalBody } from './modal-body';
import { PayrunDetailApproverModalProps } from './payrun-approvers-detail-modal.types';
import { usePayrunModalHelper } from './use-payrun-approvers-modal-helper';

export const PayrunApprovalDetailModal = (
  props: Readonly<PayrunDetailApproverModalProps>,
) => {
  const {
    isModalOpen,
    isEdit,
    dialogProps,
    handleCancel,
    handleEdit,
    onSubmit,
    onDelete,
    deletePromptRef,
    modalBodyRef,
    name,
    firstName,
    lastName,
    profilePhoto,
  } = usePayrunModalHelper(props);

  return (
    <>
      <Modal.Dialog {...dialogProps}>
        {isModalOpen ? (
          <Modal>
            <Modal.Slot
              name={ModalDialogSlot.CloseButton}
              render={
                <Modal.CloseButton
                  onClick={handleCancel}
                  id="payrun-approver-detail-modal-close-button"
                  ariaLabel="close button"
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Header}
              render={
                <Modal.Header
                  title={name ?? ''}
                  headerIcon={{
                    icon: (
                      <Avatar
                        user={{ firstName, lastName, profilePhoto }}
                        size={AvatarSize.s}
                      />
                    ),
                  }}
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Body}
              render={
                <Modal.Body>
                  {!isEdit ? (
                    <ModalBody {...props} />
                  ) : (
                    <EditPayrunApprovers
                      companyId={props.companyId}
                      userId={props.userId}
                      ref={modalBodyRef}
                    />
                  )}
                </Modal.Body>
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Footer}
              render={
                !isEdit ? (
                  <Modal.Footer
                    btnPrimary={{
                      onClick: handleEdit,
                      label: 'Edit',
                      ariaLabel: 'Edit',
                      type: ButtonType.Secondary,
                    }}
                    btnTertiary={{
                      onClick: () => {
                        deletePromptRef.current?.openModalDialog();
                      },
                      label: 'Remove',
                      ariaLabel: 'Remove',
                      type: ButtonType.Tertiary,
                      variant: ButtonVariant.Error,
                      icon: <DawnTrash fontSize={16} />,
                    }}
                  />
                ) : (
                  <Modal.Footer
                    btnPrimary={{
                      onClick: onSubmit,
                      label: 'Save',
                      ariaLabel: 'Save',
                      type: ButtonType.Primary,
                    }}
                    btnTertiary={{
                      onClick: handleCancel,
                      label: 'Cancel',
                      ariaLabel: 'Cancel',
                      type: ButtonType.Tertiary,
                    }}
                  />
                )
              }
            />
          </Modal>
        ) : null}
      </Modal.Dialog>
      {isModalOpen ? (
        <DeletePrompt name={name} confirmCallback={onDelete} ref={deletePromptRef} />
      ) : null}
    </>
  );
};
